import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { MainService} from './main.service';

@Injectable()
export class SchedulingReportService {

  constructor(public http: Http, public mainService: MainService) { }

  findAll() {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"schedulingReports")
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  findByUser(idUser:String) {
    let promise = new Promise((resolve, reject) => {
      this.http.get(this.mainService.server_url+"schedulingReports/findByUser/"+idUser)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  create(schedulingReport:any){
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"schedulingReports",schedulingReport)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  edit(schedulingReport:any){
    let promise = new Promise((resolve, reject) => {
      this.http.put(this.mainService.server_url+"schedulingReports/id;idUser="+schedulingReport.idUser+";idSchedule="+schedulingReport.idSchedule,schedulingReport)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  remove(idUser:String,idSchedule:String){
    let promise = new Promise((resolve, reject) => {
      this.http.delete(this.mainService.server_url+"schedulingReports/id;idUser="+idUser+";idSchedule="+idSchedule)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  resend(schedulingReport:any){
    let promise = new Promise((resolve, reject) => {
      this.http.post(this.mainService.server_url+"schedulingReports/resend",schedulingReport)
        .toPromise()
        .then(
          res => { // Success
            resolve(res.json());
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/scheduling-report.service.ts